import L from "leaflet";
import "leaflet/dist/leaflet.css";

const MapHandler = (markers, mapId) => {
  const map = L.map(`leaflet_${mapId}`).setView([46.22, 2.21], 5);
  let markersArray = [];

  // On ajoute la couche OSM
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    attribution: "© OpenStreetMap",
  }).addTo(map);

  // On ajoute tous nos marqueurs
  markers.forEach(function (item) {
    let marker = L.marker([item.lat, item.lng]);
    marker.item = item;

    let popupTpl = `
        <h2 class="heading heading--h2">${item.title}</h2>
        <p>${item.address}<br>${item.zipcode} ${item.city}</p>
        ${item.public && (item.phone || item.email || item.website) ? `<h3 class="heading heading--h3">Réservations&nbsp;:</h3><p>` : ``}
        ${item.public && item.phone ? `Tél&nbsp;: <a href="tel:${item.phone.replace(/\D+/g, "")}">${item.phone}</a><br>` : ``}
        ${item.public && item.email ? `Email&nbsp;: <a href="mailto:${item.email}">${item.email}</a><br>` : ``}
        ${item.public && item.website ? `Site internet&nbsp;: <a href="${item.website}" target="_blank">${item.website}</a>` : ``}
        ${item.public && (item.phone || item.email || item.website) ? `</p>` : ``}
        <p><button type="button" data-lat="${item.lat}" data-lng="${item.lng}" class="route">Itinéraire</button></p>
    `;

    marker.bindPopup(popupTpl);

    // Gestion de l'icône
    if (item.public != undefined) {
      var icon = L.icon({
        iconUrl:
          item.public == 1
            ? "/wp-content/themes/tribu/assets/svg/map-marker-white.svg"
            : "/wp-content/themes/tribu/assets/svg/map-marker.svg",
        iconSize: [38, 56],
        iconAnchor: [19, 56],
        popupAnchor: [0, -50],
      });

      marker.setIcon(icon);
    }

    markersArray.push(marker);
  });

  // On cale la carte proprement
  var group = L.featureGroup(markersArray).addTo(map);
  map.fitBounds(group.getBounds());

  // Gestion des filtres
  document
    .getElementById("filter-map")
    .addEventListener("click", function (event) {
      var zipcode = document.getElementById("zipcode").value;
      var openPublic = document.getElementById("public").value;

      var result1 = markersArray.filter(function (m) {
        return zipcode != "" ? m.item.zipcode == zipcode : true;
      });

      var result2 = result1.filter(function (m) {
        return openPublic != "" ? openPublic == !!m.item.public : true;
      });

      group.clearLayers();

      if (result2.length) {
        group = L.featureGroup(result2).addTo(map);
        map.fitBounds(group.getBounds());
      }
    });
};

export default MapHandler;
